import { render, staticRenderFns } from "./SenderReadOnlyCmp.vue?vue&type=template&id=7780c8c8&scoped=true"
import script from "./SenderReadOnlyCmp.vue?vue&type=script&lang=js"
export * from "./SenderReadOnlyCmp.vue?vue&type=script&lang=js"
import style0 from "./SenderReadOnlyCmp.vue?vue&type=style&index=0&id=7780c8c8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7780c8c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7780c8c8')) {
      api.createRecord('7780c8c8', component.options)
    } else {
      api.reload('7780c8c8', component.options)
    }
    module.hot.accept("./SenderReadOnlyCmp.vue?vue&type=template&id=7780c8c8&scoped=true", function () {
      api.rerender('7780c8c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/serviceOroviderOrder/component/EditCmp/SenderReadOnlyCmp.vue"
export default component.exports